function Information() {
    return (
        <div>
            <h1 className="text-2xl py-4">Information</h1>
        </div>
    );
}

export default Information;